import fetch from '@/assets/js/src/util/fetch'
import { checkResponse, handleException, } from '@/assets/js/src/util/apiTools'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import { defineStore, } from 'pinia'

const API_POST_APIKEY = '/api/webmasters/key'
const API_GET_TRANSLATIONS = '/api/webmasters/bibles'

export const useWebmasterStore = defineStore('webmaster', {
    state () {
        return {
            bibles: [],
            meta: {},
        }
    },
    actions: {
        async fetchBibles () {
            try {
                // Api-Request senden
                let useCache = true
                let apiResponse = await fetch({
                    url: API_GET_TRANSLATIONS,
                    options: {
                        headers: getDefaultHeaders({
                            useCache,
                        }),
                    },
                    useCache,
                    tags: [
                        'bibles',
                    ],
                })

                // Prüfen der Api Antwort
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }
                
                this.meta = apiResponse.data.meta
                this.bibles = apiResponse.data.bibles
            } catch (e) {
                handleException(e, false, false)
            }
        },

        async fetchApiKey (domain) {
            try {
                // Api-Request senden
                let apiResponse = await fetch({
                    url: API_POST_APIKEY,
                    options: {
                        method: 'POST',
                        body: JSON.stringify({
                            domain,
                        }),
                        plain: true,
                        headers: getDefaultHeaders({}),
                    },
                })

                // Prüfen der Api Antwort
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                return apiResponse.data
            } catch (e) {
                handleException(e, true, true)
            }
        },
    },
})
